module.exports = __webpack_public_path__ + "components/profile/static/icon-arrow-up-5cbed19fca25fd689147c10760488551.svg";